/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.sync.getRepo'

export { $nsid }

/** Download a repository export as CAR file. Optionally only a 'diff' since a previous revision. Does not require auth; implemented by PDS. */
const main = l.query(
  $nsid,
  l.params({
    did: l.string({ format: 'did' }),
    since: l.optional(l.string({ format: 'tid' })),
  }),
  l.payload('application/vnd.ipld.car'),
  ['RepoNotFound', 'RepoTakendown', 'RepoSuspended', 'RepoDeactivated'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
